class imgGrid extends HTMLElement {
  connectedCallback() {
    this.setupVideos();

    // 스크롤 고정 효과 — 에디터 setting(enable_scroll_pin)으로 토글.
    if (this.dataset.scrollPin === "false") return;

    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);

    const section = this.closest(".section-img-grid");
    if (!section) return;

    // gsap.matchMedia()는 미디어쿼리 미일치 시 콜백 안에서 만든
    // ScrollTrigger·pin-spacer를 자동 revert → 수동 unwrap 불필요.
    this.mm = gsap.matchMedia();
    this.mm.add("(min-width: 1024px)", () => {
      // 빈 타임라인 + pin은 의도된 freeze 동작(섹션이 자기 높이만큼 고정).
      gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top top",
          scrub: 1,
          pin: true,
        },
      });
    });
  }

  disconnectedCallback() {
    if (this.mm) this.mm.revert();
    if (this._videoMq && this._onVideoMqChange) {
      this._videoMq.removeEventListener("change", this._onVideoMqChange);
    }
  }

  setupVideos() {
    const blocks = this.querySelectorAll(".img-grid__block");
    if (!blocks.length) return;

    this._videoMq = window.matchMedia("(max-width: 749px)");

    const apply = () => {
      blocks.forEach((block) => {
        const desktop = block.querySelector(".img-grid__block-media--desktop video");
        const mobile = block.querySelector(".img-grid__block-media--mobile video");
        const active = this._videoMq.matches ? mobile || desktop : desktop || mobile;

        [desktop, mobile].forEach((video) => {
          if (!video) return;
          if (video === active) {
            if (video.preload === "none") video.preload = "auto";
            const playback = video.play();
            if (playback && playback.catch) playback.catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    };

    this._onVideoMqChange = apply;
    apply();
    this._videoMq.addEventListener("change", apply);
  }
}

customElements.define('img-grid', imgGrid);
